import classNames from "classnames";
import React, {
    HTMLAttributes,
    MouseEventHandler,
    ReactElement,
    ReactNode,
} from "react";
import Button from "../button/Button";

export const VARIANT = ["primary", "success", "danger", "warning", "yield", "outline", "disabled"] as const;
export type AlertVariantType = typeof VARIANT[number];

export interface ButtonProps extends HTMLAttributes<HTMLDivElement> {
    variant?: AlertVariantType;
    prefixIcon?: ReactNode,
    actionText?: ReactNode,
    actionButton?: ReactNode,
    onActionClick?: MouseEventHandler,
    onClose?: MouseEventHandler,
}

const Alert = React.forwardRef((
    args: ButtonProps,
    ref: React.ForwardedRef<HTMLDivElement>,
): ReactElement => {
    const {
        variant, className, prefixIcon, actionText, actionButton, onActionClick, onClose, ...rest
    } = args;

    return (
        <div
            {...rest}
            ref={ref}
            className={classNames(
                "alert",
                variant ? `alert-${variant}` : "",
                "d-flex align-items-center",
                className,
            )}
        >
            {prefixIcon && (
                <div className="alert-icon" aria-label="Alert Icon">
                    {prefixIcon}
                </div>
            )}

            <div className="flex-grow-1">
                {args.children}
            </div>

            {actionButton}
            {actionText && onActionClick && (
                <button type="button" onClick={onActionClick} className="btn alert-action">
                    {actionText}
                </button>
            )}
            {onClose && (
                <Button
                    isClose
                    variant="none"
                    size="small"
                    aria-label="Close the alert"
                    onClick={onClose}
                    className="alert-close"
                />
            )}

        </div>
    );
});

Alert.defaultProps = {
    variant: undefined,
    className: "",
    prefixIcon: undefined,
};

export default Alert;
